// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"6f7e7216","135":"f9b8e4e6","787":"e75d53e9","820":"d7c57662","930":"ab2c3084"}[chunkId] + ".chunk.js";
};